import t from "react";
import { useNavigation as c } from "../hooks/useNavigation.js";
function r() {
  const {
    back: n,
    canGoBack: e
  } = c();
  return e ? /* @__PURE__ */ t.createElement("i", { onClick: () => n(), className: "lni lni-chevron-left" }) : null;
}
export {
  r as BackIcon
};
//# sourceMappingURL=BackIcon.js.map
